import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { Day } from 'lumen/models';

// Note: Lossearch id examples:
// 0,2020-05-11,latest,
// 0,2020-05-11,latest,1
// 0,2020-05-11,latest,4-7
// 0,2020-05-11,latest,8-
// 0,2020-05-18,2020-04-20,3

// <type>,<day>,<extract date>,<los info>

// <los info can have multiple values:
//   no value -> staythrough
//   specific value (1, 2, 3) -> specific LOS
//   4-7 -> min LOS of 4, max LOS OF 7
//   8-14 -> min LOS of 8, max LOS of 14
export default class Lossearch extends Model {
  [Type] = 'lossearch' as const;

  @belongsTo('day', { async: false, inverse: 'lossearches' })
  declare day: Day;

  // Used for the overview searches
  @attr('dayjs') declare endDay: DayjsTransformReturn;
  @attr('dayjs') declare extractDate: DayjsTransformReturn;
  @attr('boolean') declare isLatest: boolean;
  @attr('number') declare maxLos: number;
  @attr('string') declare message: string;
  @attr('number') declare minLos: number;
  @attr('number') declare numSearches: number;
  @attr('number') declare searchFractionArrival: number;
  @attr('number') declare searchFractionTotal: number;
  @attr('number') declare type: number;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get losRangeFormatted() {
    if (this.minLos && this.maxLos) {
      if (this.minLos === this.maxLos) {
        return `LOS${this.minLos}`;
      }

      return `LOS${this.minLos}-${this.maxLos}`;
    }

    return 'staythrough';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get searchFractionArrivalAsPercentage() {
    return this.searchFractionArrival * 100;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get searchFractionTotalAsPercentage() {
    return this.searchFractionTotal * 100;
  }
}
